const template = {
    name: "Default NEC3 PSC v4.2 16/07/2025",
    isSystemDefault: true,
    isGlobal: true,
    companies: [],
    resources: [
        {
            id: 1,
            type: "TEXT",
            key: "SUPPLIER_NAME",
            value: "Consultant"
        },
        {
            id: 2,
            type: "TEXT",
            key: "SUPPLIER_ABBREVIATION",
            value: "CON"
        },
        {
            id: 3,
            type: "TEXT",
            key: "PM_NAME",
            value: "Employer"
        },
        {
            id: 4,
            type: "TEXT",
            key: "PM_ABBREVIATION",
            value: "EMP"
        },
        {
            id: 5,
            type: "TEXT",
            key: "SUPERVISOR_NAME",
            value: "Supervisor"
        },
        {
            id: 6,
            type: "TEXT",
            key: "SUPERVISOR_ABBREVIATION",
            value: "SUP"
        },
        {
            id: 7,
            type: "TEXT",
            key: "CLIENT_NAME",
            value: "Employer"
        },
        {
            id: 8,
            type: "NUMBER",
            key: "SUPPLIER_REPLY_PERIOD",
            value: 7
        },
        {
            id: 9,
            type: "NUMBER",
            key: "PM_REPLY_PERIOD",
            value: 7
        },
        {
            id: 10,
            type: "NUMBER",
            key: "QUOTE_DURATION",
            value: 14
        },
        {
            id: 13,
            type: "NUMBER",
            key: "REQUOTE_DURATION",
            value: 21
        },
        {
            id: 11,
            type: "NUMBER",
            key: "QUOTE_RESPONSE",
            value: 14
        },
        {
            id: 14,
            type: "NUMBER",
            key: "REQUOTE_RESPONSE",
            value: 14
        },
        {
            id: 12,
            type: "NUMBER",
            key: "VARIATION_RESPONSE",
            value: 7
        },
        {
            id: 16,
            type: "NUMBER",
            key: "PROGRAMME_REPLY_PERIOD",
            value: 14
        },
        {
            id: 10,
            type: "TEXT",
            key: "QUOTE_DEEMED_ACCEPTANCE_STARTS",
            value: "RELATED_NOTICE"
        },
        {
            id: 25,
            type: "NUMBER",
            key: "QUOTE_DEEMED_ACCEPTANCE",
            value: 14
        },
        {
            id: 39,
            type: "TEXT",
            key: "CEN_DEEMED_ACCEPTANCE_STARTS",
            value: "RELATED_NOTICE"
        },
        {
            id: 40,
            type: "NUMBER",
            key: "CEN_DEEMED_ACCEPTANCE",
            value: 14
        }
    ],
    workflowGroups: [
        {
            id: 101,
            title: "Early Warnings",
            workflows: [
                {
                    id: 1,
                    title: "$PM_NAME Early Warnings",
                    notificationName: "Early Warning",
                    abbreviation: "$PM_ABBREVIATION-Warning-",
                    notify: true,
                    replyEnabled: true,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
                    replyPeriod: 0,
                    notifyingParty: "PM",
                    replyingParty: "SUPPLIER",
                    actioningParty: "PM",
                    resolveActioningParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Support\"],\"or\",[\"rolepermissions\",\"=\",\"Manager\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        actionTab: {
                            actionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]",
                        resolveActionTab: {
                            resolveActionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        }
                    }
                },
                {
                    id: 2,
                    title: "$SUPPLIER_NAME Early Warnings",
                    notificationName: "Early Warning",
                    abbreviation: "$SUPPLIER_ABBREVIATION-Warning-",
                    notify: true,
                    replyEnabled: true,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "PM_REPLY_PERIOD",
                    replyPeriod: 0,
                    notifyingParty: "SUPPLIER",
                    replyingParty: "PM",
                    actioningParty: "PM",
                    resolveActioningParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Support\"],\"or\",[\"rolepermissions\",\"=\",\"Manager\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        actionTab: {
                            actionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]",
                        resolveActionTab: {
                            resolveActionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        }
                    }
                },
                {
                    id: 3,
                    title: "Risk Register",
                    notificationName: "Early Warning",
                    abbreviation: "Warning",
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "MeetingRequiredLabel",
                            display: "Is a risk reduction meeting required?",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "NotificationClause",
                            display: "You are given early warning of a matter which could",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "RiskItemsLabel",
                            display: "You are given early warning of a matter which could",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "RiskTypes",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "riskincreaseprice",
                            display: "increase the total of the Prices",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "riskdelaycompletion",
                            display: "delay Completion",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "riskchangeprogramme",
                            display: "dhange the Accepted Programme",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "riskdelaymilestone",
                            display: "delay meeting a Key Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "riskimpairperformance",
                            display: "impair the usefulness of the services to the Employer",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "riskaffectwork",
                            display: "affect the work of the Employer, an Employer's contractor or another consultant",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "riskotherpartner",
                            display: "affect the achievement of another Partner's objectives",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "RiskTypesSupplier",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "riskincreaseprice",
                            display: "increase the total of the Prices",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "riskdelaycompletion",
                            display: "delay Completion",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "riskchangeprogramme",
                            display: "change the Accepted Programme",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "riskdelaymilestone",
                            display: "delay meeting a Key Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "riskimpairperformance",
                            display: "impair the usefulness of the services to the Employer",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "riskaffectwork",
                            display: "affect the work of the Employer, an Employer's contractor or another consultant",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "riskotherpartner",
                            display: "affect the achievement of another Partner's objectives",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "riskincreasecontractorcost",
                            display: "increase the $SUPPLIER_NAME's total cost",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "MeetingOptions",
                    values: [
                        {
                            id: 1,
                            isActive: false,
                            field: "0",
                            display: "Extra meeting not required",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "1",
                            display: "To be discussed at the next scheduled risk reduction meeting",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "2",
                            display: "Propose risk reduction meeting",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Pm",
                            display: "$WF_1_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Supplier",
                            display: "$WF_2_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Client",
                            display: "$WF_74_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "RiskStatusOptions",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Mitigated",
                            display: "Mitigated",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "NotMitigated",
                            display: "Not mitigated",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 102,
            title: "Instructions",
            workflows: [
                {
                    id: 4,
                    title: "$PM_NAME Instruction",
                    notificationName: "Instruction",
                    abbreviation: "$PM_ABBREVIATION-Instruction-",
                    notify: true,
                    replyEnabled: false,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
                    replyPeriod: 0,
                    resubmitPeriodOption: "PM_REPLY_PERIOD",
                    resubmitPeriod: 0,
                    notifyingParty: "PM",
                    replyingParty: "SUPPLIER",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "InstructionTypes",
                    values: [
                        {
                            id: 2,
                            isActive: true,
                            field: "",
                            display: "11.2(24) to carry out a Task (main Option G)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "",
                            display: "16.1 to resolve an ambiguity or inconsistency",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "",
                            display: "17.1 to change the Scope to remove something which is illegal or impossible",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: true,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "PM",
                                    actionType: "WF_5",
                                    timePeriod: "CUSTOM"
                                }
                            ]
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "",
                            display: "18.1 on how to deal with a prevention event",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "",
                            display: "20.2 to change the Scope or a Key Date",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: true,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "PM",
                                    actionType: "WF_5",
                                    timePeriod: "CUSTOM"
                                }
                            ]
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "",
                            display: "22.2 to remove a person",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "",
                            display: "24.4 to submit proposed contract data for a subcontract (main Options C and E)",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "SUPPLIER",
                                    actionType: "WF_18",
                                    timePeriod: "SUPPLIER_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "",
                            display: "32.2 to submit a revised programme",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "SUPPLIER",
                                    actionType: "WF_14",
                                    timePeriod: "SUPPLIER_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "",
                            display: "33.1 to stop or not start work",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: true,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "PM",
                                    actionType: "WF_5",
                                    timePeriod: "CUSTOM"
                                }
                            ]
                        },
                        {
                            id: 16,
                            isActive: true,
                            field: "",
                            display: "33.1 to start or restart work",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "",
                            display: "34.1 to submit a quotation for acceleration",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "SUPPLIER",
                                    actionType: "WF_19",
                                    timePeriod: "SUPPLIER_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 13,
                            isActive: true,
                            field: "",
                            display: "40.3 to correct a failure to comply with the quality plan",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 14,
                            isActive: true,
                            field: "",
                            display: "62.1 to submit alternative quotations for a compensation event",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 15,
                            isActive: true,
                            field: "",
                            display: "Other Instruction",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "PM",
                            display: "$WF_4_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Supervisor",
                            display: "$WF_61_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Client",
                            display: "$WF_56_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 103,
            title: "Compensation Events",
            workflows: [
                {
                    id: 5,
                    title: "$PM_NAME Compensation Events",
                    notificationName: "Compensation Event",
                    abbreviation: "$PM_ABBREVIATION-Compensation-",
                    notify: true,
                    financialLimitEnabled: false,
                    assetFieldsEnabled: false,
                    notifyingParty: "PM",
                    quotingParty: "SUPPLIER",
                    quoteReplyingParty: "PM",
                    quoteNotificationName: "Quote",
                    quoteReferencePrefix: "Quote-",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        quoteMainNotice: {
                            createQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        quoteReplyNotice: {
                            saveQuoteDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateQuoteReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                },
                {
                    id: 6,
                    title: "$PM_NAME Proposed Instructions",
                    notificationName: "Proposed Instruction",
                    abbreviation: "$PM_ABBREVIATION-PROP-",
                    notify: true,
                    financialLimitEnabled: false,
                    assetFieldsEnabled: false,
                    notifyingParty: "PM",
                    quotingParty: "SUPPLIER",
                    quoteReplyingParty: "PM",
                    quoteNotificationName: "Quote",
                    quoteReferencePrefix: "Quote-",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        quoteMainNotice: {
                            createQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        quoteReplyNotice: {
                            saveQuoteDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateQuoteReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                },
                {
                    id: 7,
                    title: "$SUPPLIER_NAME Compensation Events",
                    notificationName: "Compensation Event",
                    abbreviation: "$SUPPLIER_ABBREVIATION-Compensation-",
                    notify: true,
                    replyEnabled: true,
                    financialLimitEnabled: false,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "VARIATION_RESPONSE",
                    replyPeriod: 0,
                    notifyingParty: "SUPPLIER",
                    replyingParty: "PM",
                    quotingParty: "SUPPLIER",
                    quoteReplyingParty: "PM",
                    quoteNotificationName: "Quote",
                    quoteReferencePrefix: "Quote-",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Support\"],\"or\",[\"rolepermissions\",\"=\",\"Manager\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        quoteMainNotice: {
                            createQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        quoteReplyNotice: {
                            saveQuoteDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateQuoteReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                },
                {
                    id: 8,
                    title: "$PM_NAME CE Assessments",
                    notificationName: "Assessment of Compensation Event",
                    abbreviation: "$PM_ABBREVIATION-CE-Assessment-",
                    notify: true,
                    financialLimitEnabled: false,
                    assetFieldsEnabled: false,
                    notifyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
                    }
                },
                {
                    id: 9,
                    title: "$PM_NAME Extensions",
                    notificationName: "Extension",
                    abbreviation: "$PM_ABBREVIATION-Extension-",
                    notify: true,
                    replyEnabled: true,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "ORIGINAL_DATE",
                    replyPeriod: 0,
                    notifyingParty: "PM",
                    replyingParty: "SUPPLIER",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Support\"],\"or\",[\"rolepermissions\",\"=\",\"Manager\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                },
                {
                    id: 10,
                    title: "$SUPPLIER_NAME Extensions",
                    notificationName: "Extension",
                    abbreviation: "$SUPPLIER_ABBREVIATION-Extension-",
                    notify: true,
                    replyEnabled: true,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "ORIGINAL_DATE",
                    replyPeriod: 0,
                    notifyingParty: "SUPPLIER",
                    replyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Support\"],\"or\",[\"rolepermissions\",\"=\",\"Manager\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                },
                {
                    id: 11,
                    title: "Master Quote Register",
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null"
                    }
                },
                {
                    id: 12,
                    title: "Master CE Register",
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null"
                    }
                },
                {
                    id: 13,
                    title: "Implemented CE Register",
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "PmAssumptionLabel",
                            display: "The quotation is to be based on the following assumptions",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "PmAssumptionNote",
                            display: "You are instructed to provide a quotation by $date.",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "SupplierDescNote",
                            display: "You are notified of the following event as a compensation event",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "ReplyAcceptedCommentLabel",
                            display: "You are notified of the $PM_NAME's decision that the event notified is a compensation event",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "ReplyRejectedCommentLabel",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "ReplyAcceptedAssumptionLabel",
                            display: "The quotation is to be based on the following assumptions",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "QuoteNote",
                            display: "We submit our quotation for compensation event $reference",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "ExtensionPMLabel",
                            display: "We require an extension to the time to reply as follows",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "ExtensionSupplierLabel",
                            display: "We require an extension to the time to reply as follows",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "AssessmentDetailLabel",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "ProposedInstructionNote",
                            display: "You are instructed to provide a quotation by $date.",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "ProposedInstructionLabel",
                            display: "The quotation is to be based on the following assumptions",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 13,
                            isActive: true,
                            field: "ReplyRejectedOptionsLabel",
                            display: "You are notified of the $PM_NAME's decision that the event notified is not a compensation event as it",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 14,
                            isActive: true,
                            field: "QuoteCostEffectLabel",
                            display: "Change to the Prices",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 15,
                            isActive: true,
                            field: "QuoteDateEffectLabel",
                            display: "Delay to planned Completion",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 16,
                            isActive: true,
                            field: "QuoteDaysEffectLabel",
                            display: "The length of time that the Completion Date is delayed",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 17,
                            isActive: true,
                            field: "AssessmentCostEffectLabel",
                            display: "Change in the Total of the Prices",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 18,
                            isActive: true,
                            field: "AssessmentDaysEffectLabel",
                            display: "Delay to planned Completion",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 19,
                            isActive: true,
                            field: "QuoteNoteProposedInstruction",
                            display: "We submit our quotation for proposed compensation event $reference",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 20,
                            isActive: true,
                            field: "ReplyAcceptedAssumptionNote",
                            display: "You are instructed to submit a quotation by $date",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "CompensationClauses",
                    values: [
                        {
                            id: 2,
                            isActive: true,
                            field: "",
                            display: "60.1(1) An instruction to change the Scope",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "",
                            display: "60.1(2) $PM_NAME does not provide access to a person, place or thing",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "",
                            display: "60.1(3) $PM_NAME does not provide something that he is to provide",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "",
                            display: "60.1(4) An instruction to stop or not start work or to change a Key Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "",
                            display: "60.1(5) $PM_NAME or Others do not work within the stated constraints",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "",
                            display: "60.1(6) $PM_NAME does not reply to a communication",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "",
                            display: "60.1(7) Change of a decision",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "",
                            display: "60.1(8) Withholds an acceptance",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "",
                            display: "60.1(9) Notification of a correction",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "",
                            display: "60.1(10) A breach by the $PM_NAME",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "",
                            display: "60.1(11) A prevention event",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 13,
                            isActive: true,
                            field: "",
                            display: "60.1(12) Correcting a Defect for which the $SUPPLIER_NAME is not liable",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 14,
                            isActive: true,
                            field: "",
                            display: "60.1(13) An instruction to change a Task Order (main Option G)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 15,
                            isActive: true,
                            field: "",
                            display: "60.1(14) $SUPPLIER_NAME receives the Task Order after the starting date for the Task Order (main Option G)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 16,
                            isActive: true,
                            field: "",
                            display: "60.1(15) A Task Completion is later than the Completion Date (main Option G)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 17,
                            isActive: true,
                            field: "",
                            display: "60.2 A correction of a mistake in the Task Schedule",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 18,
                            isActive: true,
                            field: "",
                            display: "X2.1 A change in the law",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 19,
                            isActive: true,
                            field: "",
                            display: "X12.3(7) A change in the Partnering Information",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 20,
                            isActive: true,
                            field: "",
                            display: "Y2.4 Suspension of performance",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ReplyRejectOptions",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "faultpscp",
                            display: "arises from a fault of the Consultant",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "notexpectnothappen",
                            display: "has not happened and is not expected to happen",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "noteffectcostcompletion",
                            display: "has no effect on either the Consultant’s costs, Completion or meeting a Key Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "statedcontract",
                            display: "is not one of the compensation events stated in this contract",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ClaimClauses",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "",
                            display: "60.1(6) Late reply to communication",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "",
                            display: "60.1(1) $PM_NAME has given an instruction to change the Scope",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "",
                            display: "60.1(3) Something not provided",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "",
                            display: "60.1(5) Work by employer or others",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "",
                            display: "60.1(7) Previous decision changed",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "",
                            display: "60.1(2) Access not provided by date stated within the contract",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "",
                            display: "60.1(4) Stop or change key date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "",
                            display: "60.1(9) $PM_NAME corrects an assumption related to a previous compensation event",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "",
                            display: "60.1(10) Breach of Contract",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "",
                            display: "60.1(8) Acceptance Withheld",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "",
                            display: "60.1(11) Prevention event",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "",
                            display: "60.1(12) Defect corrected which was not the $SUPPLIER_NAME's liability",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 13,
                            isActive: true,
                            field: "",
                            display: "60.1(13): Instruction to change Task Order issued by $PM_NAME",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 14,
                            isActive: true,
                            field: "",
                            display: "60.1(14): Consultant receives late Task Order",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 15,
                            isActive: true,
                            field: "",
                            display: "60.1(15): a Task Completion Date is later than the Completion Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 16,
                            isActive: true,
                            field: "",
                            display: "X2.1: Change in law",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "InstructionReplyProceedOpts",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "61.1",
                            display: "Consultant is instructed to proceed with works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "61.2",
                            display: "Consultant is instructed to NOT proceed with works until instructed",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "QuoteStatuses",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "0",
                            display: "Not Accepted - $SUPPLIER_NAME to resubmit",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "1",
                            display: "Accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "2",
                            display: "Awaiting Response",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "3",
                            display: "Not Accepted - $PM_ABBREVIATION to make assessment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "4",
                            display: "Not Accepted - Other quote approved",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "5",
                            display: "Not Accepted - Proposed instruction will not be given",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "6",
                            display: "Awaiting Deemed Acceptance",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "7",
                            display: "Deemed Accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "none",
                            display: "Not Communicated",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "8",
                            display: "Acknowledged",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "9",
                            display: "Not Accepted - Process ended",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "10",
                            display: "Assessed",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "CompensationStatuses",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "APMA",
                            display: "Quote Not Accepted - $PM_ABBREVIATION to make own Assessment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "ARQ",
                            display: "Quote Not Accepted - $SUPPLIER_NAME to resubmit",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "AM",
                            display: "$PM_ABBREVIATION Assessment Made",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "QA",
                            display: "Quote Accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "APMRQ",
                            display: "Awaiting $PM_ABBREVIATION Response to quote",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "APMR",
                            display: "Awaiting $PM_ABBREVIATION Response to CEN",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "AQ",
                            display: "Awaiting Quote",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "NC",
                            display: "Not Communicated",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "R",
                            display: "Not a Compensation Event",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "DNG",
                            display: "Proposed instruction will not be given",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "ADAQ",
                            display: "Awaiting Deemed Acceptance of Quote",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "DA",
                            display: "Deemed Accepted",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "RelatedCompensationText",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "RelatedCompensationText",
                            display: "Regarding the aforementioned instruction, you are hereby notified of a compensation event under clause 61.1",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "PmCompensationAQ",
                            display: "$WF_5_TITLE awaiting quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "PmCompensationARQ",
                            display: "$WF_5_TITLE awaiting revised quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "PmCompensationAPMRQ",
                            display: "$WF_5_TITLE awaiting reply to quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "PmCompensationAPMA",
                            display: "$WF_5_TITLE awaiting assessment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "SupCompensationAQ",
                            display: "$WF_7_TITLE awaiting quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "SupCompensationARQ",
                            display: "$WF_7_TITLE awaiting revised quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "SupCompensationAPMR",
                            display: "$WF_7_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "SupCompensationAPMRQ",
                            display: "$WF_7_TITLE awaiting reply to quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "SupCompensationAPMA",
                            display: "$WF_7_TITLE awaiting assessment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "PmProposedAQ",
                            display: "$WF_6_TITLE awaiting quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "PmProposedARQ",
                            display: "$WF_6_TITLE awaiting revised quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "PmProposedAPMRQ",
                            display: "$WF_6_TITLE awaiting reply to quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 13,
                            isActive: true,
                            field: "PmProposedAPMA",
                            display: "$WF_6_TITLE awaiting assessment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 15,
                            isActive: true,
                            field: "SupAssumption",
                            display: "$WF_42_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 21,
                            isActive: true,
                            field: "SupClaimAPMR",
                            display: "$WF_37_TITLE awaiting reply to notice",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 16,
                            isActive: true,
                            field: "SupClaimAQ",
                            display: "$WF_37_TITLE awaiting quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 17,
                            isActive: true,
                            field: "SupClaimARQ",
                            display: "$WF_37_TITLE awaiting revised quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 19,
                            isActive: true,
                            field: "SupClaimAPMRQ",
                            display: "$WF_37_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 20,
                            isActive: true,
                            field: "SupClaimAPMA",
                            display: "$WF_37_TITLE awaiting determination",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 22,
                            isActive: true,
                            field: "replydraftpmcequotessupplier",
                            display: "$WF_7_TITLE quotations",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 25,
                            isActive: true,
                            field: "COMPENSATION_CWN_APMR",
                            display: "$WF_67_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 23,
                            isActive: true,
                            field: "COMPENSATION_CWN_AQ",
                            display: "$WF_67_TITLE awaiting reply awaiting full details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 24,
                            isActive: true,
                            field: "COMPENSATION_CWN_ARQ",
                            display: "$WF_67_TITLE awaiting reply awaiting revised details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 26,
                            isActive: true,
                            field: "COMPENSATION_CWN_APMRQ",
                            display: "$WF_67_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 27,
                            isActive: true,
                            field: "COMPENSATION_CWN_APMA",
                            display: "$WF_67_TITLE awaiting determination",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 28,
                            isActive: true,
                            field: "COMPENSATION_CLIENTCWN_AQ",
                            display: "$WF_75_TITLE awaiting full details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 29,
                            isActive: true,
                            field: "COMPENSATION_CLIENTCWN_ARQ",
                            display: "$WF_75_TITLE awaiting revised details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 30,
                            isActive: true,
                            field: "COMPENSATION_CLIENTCWN_APMR",
                            display: "$WF_75_TITLE awaiting reply to notice",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 31,
                            isActive: true,
                            field: "COMPENSATION_CLIENTCWN_APMRQ",
                            display: "$WF_75_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 32,
                            isActive: true,
                            field: "COMPENSATION_CLIENTCWN_APMA",
                            display: "$WF_75_TITLE awaiting determination",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 33,
                            isActive: true,
                            field: "COMPENSATION_CLIENT_AQ",
                            display: "$WF_76_TITLE awaiting quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 34,
                            isActive: true,
                            field: "COMPENSATION_CLIENT_ARQ",
                            display: "$WF_76_TITLE awaiting revised quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 35,
                            isActive: true,
                            field: "COMPENSATION_CLIENT_APMR",
                            display: "$WF_76_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 36,
                            isActive: true,
                            field: "COMPENSATION_CLIENT_APMRQ",
                            display: "$WF_76_TITLE awaiting reply to quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 37,
                            isActive: true,
                            field: "COMPENSATION_CLIENT_APMA",
                            display: "$WF_76_TITLE awaiting assessment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 14,
                            isActive: true,
                            field: "PmExtension",
                            display: "$WF_9_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 38,
                            isActive: true,
                            field: "SupExtension",
                            display: "$WF_10_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "CompensationEventsAcceptanceOptions",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "1",
                            display: "Is a compensation event",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "0",
                            display: "Is not a compensation event",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 104,
            title: "Programme",
            workflows: [
                {
                    id: 14,
                    title: "$SUPPLIER_NAME Programme",
                    notificationName: "Programme",
                    abbreviation: "$SUPPLIER_ABBREVIATION-Programme-",
                    notify: true,
                    replyEnabled: true,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "PROGRAMME_REPLY_PERIOD",
                    replyPeriod: 0,
                    resubmitPeriodOption: "SUPPLIER_REPLY_PERIOD",
                    resubmitPeriod: 0,
                    notifyingParty: "SUPPLIER",
                    replyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Support\"],\"or\",[\"rolepermissions\",\"=\",\"Manager\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "ReasonLabel",
                            display: "Reason for any change to Planned Completion",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "ChangeLabel",
                            display: "Change in any other Key Date, Completion Date for a section or other important project milestone in period and reasons why",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "MainProgressLabel",
                            display: "Main progress achieved in period",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "KeyActivitiesLabel",
                            display: "Key activities forecast in next four weeks",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "SummaryLabel",
                            display: "Summary of critical path",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "ChangesLabel",
                            display: "Main changes made to programme in period, e.g. items deleted, new sections or activities added etc.",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "CompensationLabel",
                            display: "Compensation events added to programme this period",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "NotificationClause",
                            display: "Please find attached programme for acceptance",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "ReplyRejectReasonLabel",
                            display: "The $SUPPLIER_NAME’s programme is not accepted for the following reasons",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "ReplyNotificationClause",
                            display: "You are notified that the $SUPPLIER_NAME’s Programme",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ReplyRejectOptions",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "plansnotpractical",
                            display: "The $SUPPLIER_NAME’s plans which it shows are not practicable",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "missingcontractrequires",
                            display: "It does not show the information which this contract requires",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "notrepresentplan",
                            display: "It does not represent the $SUPPLIER_NAME's plans realistically",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "notcomply",
                            display: "It does not comply with the Scope",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "UnifiedReplyOptions",
                    values: [
                        {
                            id: 1,
                            wfid: 14,
                            isActive: true,
                            field: "ACCEPT",
                            display: "Accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            wfid: 14,
                            isActive: false,
                            field: "ACCEPT_WITH_COMMENTS",
                            display: "Accepted with comments",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            wfid: 14,
                            isActive: true,
                            field: "NOT_ACCEPTED",
                            display: "Not accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            wfid: 14,
                            isActive: true,
                            field: "NOT_ACCEPTED_RESUBMIT",
                            display: "Not accepted - resubmission required",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "SUPPLIER",
                                    actionType: "WF_14",
                                    timePeriod: "SUPPLIER_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 5,
                            wfid: 14,
                            isActive: false,
                            field: "NO_REPLY_REQUIRED",
                            display: "Reply not required",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "Fields",
                    values: [
                        {
                            id: 10,
                            isActive: true,
                            field: "Type",
                            display: "Type",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 1,
                            isActive: true,
                            field: "PreviousPlanned",
                            display: "Previous Planned Completion",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "PlannedCompletion",
                            display: "Date of Planned Completion this period",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Reason",
                            display: "Reason for any change to Planned Completion",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "Change",
                            display: "Change in any other Key Date, Sectional Completion or other important project milestone in period and reasons why",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "MainProgress",
                            display: "Main progress achieved in period",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "KeyActivities",
                            display: "Key activities forecast in next four weeks",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "Summary",
                            display: "Summary of critical path",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "Changes",
                            display: "Main changes made to programme in period, e.g. items deleted, new sections or activities added etc.",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "Compensation",
                            display: "Compensation events added to programme this period",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Supplier",
                            display: "$WF_14_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 105,
            title: "Notifications",
            workflows: [
                {
                    id: 15,
                    title: "$PM_NAME Notifications",
                    notificationName: "Notification",
                    abbreviation: "$PM_ABBREVIATION-Notification-",
                    notify: true,
                    replyEnabled: false,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
                    replyPeriod: 0,
                    resubmitPeriodOption: "PM_REPLY_PERIOD",
                    resubmitPeriod: 0,
                    notifyingParty: "PM",
                    replyingParty: "SUPPLIER",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"]]"
                    }
                },
                {
                    id: 16,
                    title: "$SUPPLIER_NAME Notifications",
                    notificationName: "Notification",
                    abbreviation: "$SUPPLIER_ABBREVIATION-Notification-",
                    notify: true,
                    replyEnabled: false,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "PM_REPLY_PERIOD",
                    replyPeriod: 0,
                    resubmitPeriodOption: "SUPPLIER_REPLY_PERIOD",
                    resubmitPeriod: 0,
                    notifyingParty: "SUPPLIER",
                    replyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"PM\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "PmClauses",
                    values: [
                        {
                            id: 2,
                            isActive: true,
                            field: "",
                            display: "13.2 of a change of address for communications",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "",
                            display: "13.5 of an agreement to extend the period for reply for a communication (excluding compensation events periods)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "",
                            display: "16.1 of an ambiguity or inconsistency",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "PM",
                                    actionType: "WF_4",
                                    timePeriod: "PM_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "",
                            display: "20.1 of provision of information required by the contract",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: false,
                            field: "",
                            display: "23.3 of the amount assessed for a failure to meet a Key Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: false,
                            field: "",
                            display: "30.2 of certification of the date of Completion",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "",
                            display: "41.2 of the amount to be paid for uncorrected Defects",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "",
                            display: "61.5 that the $PM_NAME has decided the $SUPPLIER_NAME did not give early warning of a compensation event",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "",
                            display: "81.2 of the insurance certificates for insurances taken out by the Employer",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "",
                            display: "90.1 of having done one of the things at clause 90.1",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "",
                            display: "90.3 that the $PM_NAME no longer wants the services or the Consultant has substantially failed to comply with this contract",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 13,
                            isActive: true,
                            field: "",
                            display: "90.4 of termination due to a prevention event",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 14,
                            isActive: true,
                            field: "",
                            display: "X10 of the name of a replacement $PM_NAME's Agent",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 15,
                            isActive: true,
                            field: "",
                            display: "X11 of termination",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 16,
                            isActive: true,
                            field: "",
                            display: "X18.3 of a matter for which the Consultant is liable",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 17,
                            isActive: true,
                            field: "",
                            display: "Y2.3 of an intention to pay less than the notified sum",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 18,
                            isActive: true,
                            field: "",
                            display: "Other notification",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "SupplierClauses",
                    values: [
                        {
                            id: 2,
                            isActive: true,
                            field: "",
                            display: "13.2 of a change of address for communications",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "",
                            display: "16.1 of an ambiguity or inconsistency",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "PM",
                                    actionType: "WF_4",
                                    timePeriod: "PM_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "",
                            display: "17.1 of an illegal or impossible requirement",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "PM",
                                    actionType: "WF_4",
                                    timePeriod: "PM_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "",
                            display: "23.2 of a meeting with Others",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "",
                            display: "41.1 of Defects that have not been corrected at Completion",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "",
                            display: "61.4 of a failure by the $PM_NAME to respond to a compensation event notification",
                            effect: "CEN_DEEM_START_INTERVAL",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "",
                            display: "62.6 of a failure by the $PM_NAME to respond to a quotation",
                            effect: "DEEM_START_INTERVAL",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "",
                            display: "64.4 of a failure by the $PM_NAME to make an assessment of a compensation event",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "",
                            display: "90.1 of having done one of the things at clause 90.1",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "",
                            display: "90.2 of termination",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 13,
                            isActive: true,
                            field: "",
                            display: "Other notification",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 4,
                            isActive: true,
                            field: "Client",
                            display: "$WF_57_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "PM",
                            display: "$WF_15_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Supervisor",
                            display: "$WF_16_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 1,
                            isActive: true,
                            field: "Supplier",
                            display: "$WF_17_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "PmToSupervisor",
                            display: "$WF_58_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "PmToClient",
                            display: "$WF_59_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "SupplierToSupervisor",
                            display: "$WF_81_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "SupervisorToPm",
                            display: "$WF_60_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "ClientToClient",
                            display: "$WF_64_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "PmToPm",
                            display: "$WF_63_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "SupplierToSupplier",
                            display: "$WF_65_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "SupervisorToSupervisor",
                            display: "$WF_66_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 106,
            title: "Submissions",
            workflows: [
                {
                    id: 18,
                    title: "$SUPPLIER_NAME Submissions",
                    notificationName: "Submission",
                    abbreviation: "$SUPPLIER_ABBREVIATION-Submission-",
                    notify: true,
                    replyEnabled: true,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "PM_REPLY_PERIOD",
                    replyPeriod: 0,
                    resubmitPeriodOption: "SUPPLIER_REPLY_PERIOD",
                    resubmitPeriod: 0,
                    notifyingParty: "SUPPLIER",
                    replyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Support\"],\"or\",[\"rolepermissions\",\"=\",\"Manager\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "IssueClauses",
                    values: [
                        {
                            id: 2,
                            isActive: true,
                            field: "",
                            display: "21.3 forecasts of total expenses for the whole of the services (main Option A)",
                            applyReplyPeriod: false,
                            noReply: true,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "",
                            display: "21.4 forecasts of total Time Charge and expenses for the whole of the services (main Option C, E and G)",
                            applyReplyPeriod: false,
                            noReply: true,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "",
                            display: "22.1 details of a replacement person",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "",
                            display: "24.2 the name of a proposed Subconsultant",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "",
                            display: "24.3 proposed subcontract documents",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "",
                            display: "24.4 proposed contract data for each subcontract (main Options C and E)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "",
                            display: "40.2 a proposed quality policy statement or quality policy plan",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "",
                            display: "51.3 further information to justify an invoice",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "",
                            display: "53.2 a revised activity schedule (main Option A and C)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "",
                            display: "71.1 a request for permission to publicise the services",
                            applyReplyPeriod: false,
                            noReply: true,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 13,
                            isActive: true,
                            field: "",
                            display: "81.2 certificates of insurance",
                            applyReplyPeriod: false,
                            noReply: true,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 14,
                            isActive: true,
                            field: "",
                            display: "91.2 information resulting from work carried out to date",
                            applyReplyPeriod: false,
                            noReply: true,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 15,
                            isActive: true,
                            field: "",
                            display: "X4.1 a parent company guarantee",
                            applyReplyPeriod: false,
                            noReply: true,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 16,
                            isActive: true,
                            field: "",
                            display: "X9.1 documents which transfer rights to the Employer",
                            applyReplyPeriod: false,
                            noReply: true,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 17,
                            isActive: true,
                            field: "",
                            display: "X13.1 a performance bond",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 19,
                            isActive: true,
                            field: "",
                            display: "X20.2 a report of performance",
                            applyReplyPeriod: false,
                            noReply: true,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 20,
                            isActive: true,
                            field: "",
                            display: "X20.3 proposals for improving performance",
                            applyReplyPeriod: false,
                            noReply: true,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 21,
                            isActive: true,
                            field: "",
                            display: "Other submission",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "UnifiedReplyOptions",
                    values: [
                        {
                            id: 1,
                            wfid: 18,
                            isActive: true,
                            field: "ACCEPT",
                            display: "Accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            wfid: 18,
                            isActive: false,
                            field: "ACCEPT_WITH_COMMENTS",
                            display: "Accepted with comments",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            wfid: 18,
                            isActive: false,
                            field: "NOT_ACCEPTED",
                            display: "Not accepted (not used as resubmission is always required under 13.4)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            wfid: 18,
                            isActive: true,
                            field: "NOT_ACCEPTED_RESUBMIT",
                            display: "Not accepted - resubmission required in accordance with clause 13.4",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "SUPPLIER",
                                    actionType: "WF_18",
                                    timePeriod: "SUPPLIER_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 5,
                            wfid: 18,
                            isActive: false,
                            field: "NO_REPLY_REQUIRED",
                            display: "Reply not required",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            wfid: 49,
                            isActive: true,
                            field: "ACCEPT",
                            display: "Accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            wfid: 49,
                            isActive: false,
                            field: "ACCEPT_WITH_COMMENTS",
                            display: "Accepted with comments",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            wfid: 49,
                            isActive: true,
                            field: "NOT_ACCEPTED",
                            display: "Not accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            wfid: 49,
                            isActive: true,
                            field: "NOT_ACCEPTED_RESUBMIT",
                            display: "Not accepted - resubmission required",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "PM",
                                    actionType: "WF_49",
                                    timePeriod: "PM_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 10,
                            wfid: 49,
                            isActive: false,
                            field: "NO_REPLY_REQUIRED",
                            display: "Reply not required",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Supplier",
                            display: "$WF_18_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "PM",
                            display: "$WF_49_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 107,
            title: "Submissions (with quote)",
            workflows: [
                {
                    id: 19,
                    title: "$SUPPLIER_NAME Submissions (wq)",
                    notificationName: "Submission",
                    abbreviation: "$SUPPLIER_ABBREVIATION-SubmissionWQ-",
                    notify: true,
                    replyEnabled: true,
                    financialLimitEnabled: false,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "PM_REPLY_PERIOD",
                    replyPeriod: 0,
                    resubmitPeriodOption: "SUPPLIER_REPLY_PERIOD",
                    resubmitPeriod: 0,
                    notifyingParty: "SUPPLIER",
                    replyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Support\"],\"or\",[\"rolepermissions\",\"=\",\"Manager\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CostEffectLabel",
                            display: "Change in the Prices",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "DaysEffectLabel",
                            display: "Delay to planned Completion",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ProposalClauses",
                    values: [
                        {
                            id: 2,
                            isActive: true,
                            field: "",
                            display: "34.1 a quotation for acceleration",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "UnifiedReplyOptions",
                    values: [
                        {
                            id: 1,
                            wfid: 19,
                            isActive: true,
                            field: "ACCEPT",
                            display: "Accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            wfid: 19,
                            isActive: false,
                            field: "ACCEPT_WITH_COMMENTS",
                            display: "Accepted with comments",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            wfid: 19,
                            isActive: false,
                            field: "NOT_ACCEPTED",
                            display: "Not accepted (not used as resubmission is always required under 13.4)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            wfid: 19,
                            isActive: true,
                            field: "NOT_ACCEPTED_RESUBMIT",
                            display: "Not accepted - resubmission required in accordance with clause 13.4",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "SUPPLIER",
                                    actionType: "WF_19",
                                    timePeriod: "SUPPLIER_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 5,
                            wfid: 19,
                            isActive: false,
                            field: "NO_REPLY_REQUIRED",
                            display: "Reply not required",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Supplier",
                            display: "$WF_19_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 116,
            title: "Forecasts",
            workflows: [
                {
                    id: 52,
                    title: "Cost Forecasts",
                    notificationName: "Cost Forecast",
                    abbreviation: "$SUPPLIER_ABBREVIATION-CostForecast-",
                    notify: true,
                    assetFieldsEnabled: false,
                    notifyingParty: "SUPPLIER",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CostForecastWarningBanner",
                            display: "The forecast is to be submitted at the interval stated in the Contract Data and in the format included in the Scope.",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "CarbonForecastWarningBanner",
                            display: "The forecast is to be submitted at the interval stated in the Contract Data for Defined Cost forecast and in the format included in the Scope.",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "TargetLabel",
                            display: "Target",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "ForecastLabel",
                            display: "Forecast",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "ActualLabel",
                            display: "Actual",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "VarianceLabel",
                            display: "Variance",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: []
                },
                {
                    replacementKey: "CostForecastClauses",
                    values: [
                        {
                            id: 10,
                            isActive: true,
                            field: "",
                            display: "NEC3 PSC Option A - as per Clause 21.3",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "",
                            display: "NEC3 PSC Option C - as per Clause 21.4",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "",
                            display: "NEC3 PSC Option E - as per Clause 21.4",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "CarbonForecastClauses",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "",
                            display: "NEC4 PSC - whole life carbon of the proposed solution",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "",
                            display: "NEC4 ECC - capital carbon of the built solution",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "CostForecastClausesEnabled",
                    values: [
                        {
                            id: 1,
                            isActive: false,
                            field: "CostForecastClausesEnabled",
                            display: "Active-Inactive state indicates \"Type\" field will be included in registers and and communication forms",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "CarbonForecastClausesEnabled",
                    values: [
                        {
                            id: 1,
                            isActive: false,
                            field: "CarbonForecastClausesEnabled",
                            display: "Active-Inactive state indicates \"Type\" field will be included in registers and communication forms",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "Fields",
                    values: [
                        {
                            id: 1,
                            isActive: false,
                            field: "Target",
                            display: "Target",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Forecast",
                            display: "Forecast",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "Actual",
                            display: "Actual",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "Variance",
                            display: "Variance",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 108,
            title: "Payments",
            workflows: [
                {
                    id: 20,
                    title: "$PM_NAME Assessment",
                    notificationName: "Assessment",
                    abbreviation: "$PM_ABBREVIATION-Assessment-",
                    notify: true,
                    financialLimitEnabled: false,
                    assetFieldsEnabled: false,
                    notifyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                },
                {
                    id: 21,
                    title: "$SUPPLIER_NAME Invoice",
                    notificationName: "Invoice",
                    abbreviation: "$SUPPLIER_ABBREVIATION-Invoice-",
                    notify: true,
                    financialLimitEnabled: false,
                    assetFieldsEnabled: false,
                    notifyingParty: "SUPPLIER",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CumulativePriceLabel",
                            display: "Price for Services Provided to Date plus expenses",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "PlusAmountsSupplierLabel",
                            display: "Plus other amounts to be paid to the $SUPPLIER_NAME",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "LessAmountsSupplierLabel",
                            display: "Less amounts to be paid by or retained from the $SUPPLIER_NAME",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "TaxSupplierLabel",
                            display: "Tax which the law requires the Employer to pay to the $SUPPLIER_NAME",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "WarningBanner",
                            display: "The first assessment date is no later than the assessment interval after the starting date. Subsequent assessment dates are the assessment interval after the previous assessment. Assessments continue until 8 weeks after the defects date with an additional assessment at Completion",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "LessAmountsDueLabel",
                            display: "Less amount due in the last Employer assessment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "PaymentAppliedPeriodLabel",
                            display: "Amount invoiced this period",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "RegisterAppliedByCaption",
                            display: "Submitted by",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "RegisterApplicationDateCaption",
                            display: "Submission Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "PaymentCertifiedPeriodLabel",
                            display: "Amount assessed this period",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "RegisterCertifiedDateCaption",
                            display: "Notified Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "RegisterCertifiedByCaption",
                            display: "Notified By",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 13,
                            isActive: true,
                            field: "SummaryDetailsLabel",
                            display: "Summary details",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "TaxEnabled",
                    values: [
                        {
                            id: 1,
                            isActive: false,
                            field: "TaxEnabled",
                            display: "Active-Inactive state indicates tax field will be included in notification forms",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "PaymentTypes",
                    values: [
                        {
                            id: 2,
                            isActive: true,
                            field: "INTERIM",
                            display: "51.1 payment certificate within three weeks of assessment date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "COMPLETION",
                            display: "Completion",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 1,
                            isActive: false,
                            field: "FINAL",
                            display: "53.1 final payment certificate",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "SUPPLEMENTARY",
                            display: "Supplementary",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: false,
                            field: "DRAFT",
                            display: "Draft",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: false,
                            field: "EXTRA",
                            display: "Extra",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: false,
                            field: "OTHER",
                            display: "Other",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ApplicationTypes",
                    values: [
                        {
                            id: 2,
                            isActive: true,
                            field: "INTERIM",
                            display: "50.1 application for payment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "COMPLETION",
                            display: "Completion",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 1,
                            isActive: false,
                            field: "FINAL",
                            display: "53.2 assessment of the final amount due",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: false,
                            field: "TERMINATION",
                            display: "Termination",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "SUPPLEMENTARY",
                            display: "Supplementary",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: false,
                            field: "DRAFT",
                            display: "Draft",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: false,
                            field: "EXTRA",
                            display: "Extra",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: false,
                            field: "OTHER",
                            display: "Other",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 119,
            title: "Other Assessments",
            workflows: [
                {
                    id: 77,
                    title: "$PM_NAME Assessments (excluding CE's and Payments)",
                    notificationName: "Assessment",
                    abbreviation: "$PM_ABBREVIATION-Other-Assessment-",
                    notify: true,
                    financialLimitEnabled: false,
                    assetFieldsEnabled: false,
                    notifyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: []
                },
                {
                    replacementKey: "ActionReminders",
                    values: []
                },
                {
                    replacementKey: "FieldsPM",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Subject",
                            display: "Subject",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Type",
                            display: "Type",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Description",
                            display: "Description",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "EffectContractPrice",
                            display: "Affect contract price",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "Amount",
                            display: "Amount",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: false,
                            field: "EffectContractCompletion",
                            display: "Affect contract date(s)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: false,
                            field: "Days",
                            display: "Time (days)",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ClausesPM",
                    values: [
                        {
                            id: 3,
                            isActive: true,
                            field: "",
                            display: "23.3 of the amount for a failure to meet a Key Date",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: false,
                            field: "",
                            display: "25.2 of the amount to be paid as the $SUPPLIER_NAME failed to provide services",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "",
                            display: "41.6 of the cost incurred by the $CLIENT_NAME in repeating a test or inspection",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: false,
                            field: "",
                            display: "46.1 of the cost to the $CLIENT_NAME of having a Defect corrected",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: false,
                            field: "",
                            display: "46.2 of the cost the $SUPPLIER_NAME would incur in correcting a Defect",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: false,
                            field: "",
                            display: "50.9 of the correct assessment of part of the Defined Cost (Option C, D, E and F)",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "",
                            display: "51.3 of interest on a corrected payment certificate",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "",
                            display: "54.3 of a preliminary amount of the $SUPPLIER_NAME's share (Option C)",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "",
                            display: "54.4 of the final amount of the $SUPPLIER_NAME's share (Option C)",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: false,
                            field: "",
                            display: "54.7 of a preliminary amount of the $SUPPLIER_NAME's share (Option C)",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 13,
                            isActive: false,
                            field: "",
                            display: "54.8 of the final amount of the $SUPPLIER_NAME's share (Option C)",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 14,
                            isActive: true,
                            field: "",
                            display: "85.1 of the cost of insurance provided by  the $CLIENT_NAME",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 15,
                            isActive: false,
                            field: "",
                            display: "86.3 of the cost of insurance provided by the $SUPPLIER_NAME",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 17,
                            isActive: true,
                            field: "",
                            display: "92.3 of the $SUPPLIER_NAME's share on termination (Option C and D)",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 18,
                            isActive: true,
                            field: "",
                            display: "X1.3 of the price adjustment added to the amount due (Options A and B)",
                            effect: "EFFECT_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 19,
                            isActive: true,
                            field: "",
                            display: "X1.4 of the price adjustment added to the Prices (Option C and D)",
                            effect: "EFFECT_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 20,
                            isActive: true,
                            field: "",
                            display: "X6.1 of the amount of bonus",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 21,
                            isActive: true,
                            field: "",
                            display: "X7.1 of the amount of delay damages",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 22,
                            isActive: false,
                            field: "",
                            display: "X14.1 of the amount of advanced payment",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 23,
                            isActive: false,
                            field: "",
                            display: "X14.3 of the amount of repayment of advanced payment",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 24,
                            isActive: false,
                            field: "",
                            display: "X16 of the amount to withhold as retention",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 25,
                            isActive: false,
                            field: "",
                            display: "X17 of the amount of low performance damages",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 26,
                            isActive: true,
                            field: "",
                            display: "X20.4 of the amount payable for meeting a target on the incentive schedule",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 27,
                            isActive: false,
                            field: "",
                            display: "X22.7(2) of the preliminary amount of the budget incentive",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 28,
                            isActive: false,
                            field: "",
                            display: "X22.7(3) of the final amount of the budget incentive",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 117,
            title: "Other Certificates",
            workflows: [
                {
                    id: 68,
                    title: "$PM_NAME Certificates",
                    notificationName: "Certificate",
                    abbreviation: "$PM_ABBREVIATION-Certificate-",
                    notify: true,
                    replyEnabled: false,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
                    replyPeriod: 0,
                    resubmitPeriodOption: "PM_REPLY_PERIOD",
                    resubmitPeriod: 0,
                    notifyingParty: "PM",
                    replyingParty: "SUPPLIER",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Cost Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "PmCertificateText",
                            display: "",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "SupplierCertificateText",
                            display: "",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "ClientCertificateText",
                            display: "",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "SupervisorCertificateText",
                            display: "",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "CompletionFields",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CertifiedDate",
                            display: "Completion Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Description",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Works",
                            display: "Outstanding Works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "Defects",
                            display: "Defects",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "SectionalCompletionFields",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CertifiedDate",
                            display: "Sectional Completion Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Description",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Works",
                            display: "Outstanding Works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "Defects",
                            display: "Defects",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "TakingOverFields",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CertifiedDate",
                            display: "Taking Over Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Description",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Works",
                            display: "Outstanding Works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "Defects",
                            display: "Defects",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "DefectsFields",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CertifiedDate",
                            display: "Certified Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Description",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "Works",
                            display: "Outstanding Works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "Defects",
                            display: "Outstanding Defects",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "TerminationFields",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CertifiedDate",
                            display: "Certified Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Description",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "Works",
                            display: "Outstanding Works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "Defects",
                            display: "Outstanding Defects",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "OtherFields",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CertifiedDate",
                            display: "Certified Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Description",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "Works",
                            display: "Outstanding Works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "Defects",
                            display: "Outstanding Defects",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "TaskOrderCompletionFields",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CertifiedDate",
                            display: "Certified Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Description",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "Works",
                            display: "Outstanding Works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "Defects",
                            display: "Outstanding Defects",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ProjectOrderCompletionFields",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CertifiedDate",
                            display: "Certified Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Description",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "Works",
                            display: "Outstanding Works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "Defects",
                            display: "Outstanding Defects",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ReplyOptions",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Accepted",
                            display: "Accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Not Accepted",
                            display: "Not Accepted",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "PMCertTypes",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "",
                            display: "30.2 Completion Certificate",
                            effect: "COMPLETION",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: false,
                            field: "",
                            display: "X5 30.2 Sectional Completion Certificate",
                            effect: "SECTIONAL_COMPLETION",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "",
                            display: "35.3 Taking Over Certificate",
                            effect: "TAKING_OVER",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: false,
                            field: "",
                            display: "43.3 Defects Certificate (NEC3 ECC)",
                            effect: "DEFECTS",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "",
                            display: "44.3 Defects Certificate",
                            effect: "DEFECTS",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: false,
                            field: "",
                            display: "90.1 Termination Certificate",
                            effect: "TERMINATION",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: false,
                            field: "",
                            display: "X19.1 Termination Certificate (NEC4 TSC)",
                            effect: "TERMINATION",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: false,
                            field: "",
                            display: "Other Certificate",
                            effect: "OTHER",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: false,
                            field: "",
                            display: "Task Order Completion",
                            effect: "TASK_ORDER_COMPLETION",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: false,
                            field: "",
                            display: "Project Order Completion",
                            effect: "PROJECT_ORDER_COMPLETION",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "CompletionChangesStateEnabled",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CompletionChangesStateEnabled",
                            display: "Indicate whether communication of a Completion Certificate should change the contract state",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "PM",
                            display: "$WF_68_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Supplier",
                            display: "$WF_69_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Client",
                            display: "$WF_70_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "Supervisor",
                            display: "$WF_71_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 109,
            title: "Quality",
            workflows: [
                {
                    id: 23,
                    title: "$PM_NAME Defect Notifications",
                    notificationName: "Defect Notification",
                    pageTitle: "$PM_NAME Defect Notification",
                    abbreviation: "$PM_ABBREVIATION-Defect-",
                    notify: true,
                    assetFieldsEnabled: false,
                    notifyingParty: "PM",
                    actioningParty: "PM",
                    resolveActioningParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        actionTab: {
                            actionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]",
                        resolveActionTab: {
                            resolveActionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        }
                    }
                },
                {
                    id: 24,
                    title: "$SUPPLIER_NAME Defect Notifications",
                    notificationName: "Defect Notification",
                    abbreviation: "$SUPPLIER_ABBREVIATION-Defect-",
                    notify: true,
                    assetFieldsEnabled: false,
                    notifyingParty: "SUPPLIER",
                    actioningParty: "PM",
                    resolveActioningParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        actionTab: {
                            actionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]",
                        resolveActionTab: {
                            resolveActionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        }
                    }
                },
                {
                    id: 26,
                    title: "Master Defect Register",
                    notificationName: "Defect Notification",
                    abbreviation: "Defect",
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "InstructionClauseLabel",
                            display: "You are instructed to search for a Defect as follows",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "SupervisorClauseLabel",
                            display: "You are notified of the following Defect",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "SupplierClauseLabel",
                            display: "You are notified of the following Defect",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "TestsClauseLabel",
                            display: "You are notified of the following test or inspection",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Instruction",
                            display: "$PM_NAME Instruction to Search awaiting sign off",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "SuperDefect",
                            display: "$PM_NAME Notification of Defect awaiting acceptance",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Inspection",
                            display: "$SUPPLIER_NAME Test/Inspection Notification awaiting sign off",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ClosureReasonOptions",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Accepted",
                            display: "Accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Corrected",
                            display: "Corrected",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "NoDefect",
                            display: "Not a Defect",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "UnifiedClauses",
                    values: [
                        {
                            id: 1,
                            wfid: 23,
                            isActive: true,
                            field: "",
                            display: "41.2 Notification of a Defect",
                            overrideResources: null,
                            postActions: []
                        },
                        {
                            id: 2,
                            wfid: 24,
                            isActive: true,
                            field: "",
                            display: "41.1 Notification of a Defect",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 111,
            title: "Records",
            workflows: [
                {
                    id: 30,
                    title: "$PM_NAME Meetings",
                    notificationName: "Meeting",
                    abbreviation: "$PM_ABBREVIATION-Meeting-",
                    notify: true,
                    assetFieldsEnabled: false,
                    notifyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
                    }
                },
                {
                    id: 31,
                    title: "$SUPPLIER_NAME Meetings",
                    notificationName: "Meeting",
                    abbreviation: "$SUPPLIER_ABBREVIATION-Meeting-",
                    notify: true,
                    assetFieldsEnabled: false,
                    notifyingParty: "SUPPLIER",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
                    }
                },
                {
                    id: 32,
                    title: "$SUPPLIER_NAME Site Diary",
                    notificationName: "Site Diary",
                    abbreviation: "Diary-",
                    notify: true,
                    assetFieldsEnabled: false,
                    notifyingParty: "SUPPLIER",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
                    }
                },
                {
                    id: 33,
                    title: "Weather",
                    notificationName: "Weather",
                    abbreviation: "Weather-",
                    notify: true,
                    assetFieldsEnabled: false,
                    notifyingParty: "SUPPLIER",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
                    }
                }
            ],
            placeholders: []
        },
        {
            id: 112,
            title: "RFI / TQ",
            workflows: [
                {
                    id: 34,
                    title: "$SUPPLIER_NAME RFI / TQ",
                    notificationName: "RFI / TQ",
                    abbreviation: "RFI/TQ-",
                    notify: true,
                    replyEnabled: true,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "ASKED_ON_COMMUNICATION_FORM",
                    replyPeriod: 0,
                    notifyingParty: "SUPPLIER",
                    replyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Support\"],\"or\",[\"rolepermissions\",\"=\",\"Manager\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Supplier",
                            display: "$WF_34_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "PM",
                            display: "$WF_80_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 113,
            title: "Contract Information",
            workflows: [
                {
                    id: 39,
                    title: "Documents",
                    notificationName: "Document",
                    abbreviation: "Documents-",
                    actioningParty: "PM",
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        actionTab: {
                            actionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        }
                    }
                },
                {
                    id: 44,
                    title: "Project Bank Accounts",
                    notificationName: "Project Bank Account",
                    abbreviation: "BankAccount-",
                    actioningParty: "PM",
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        actionTab: {
                            actionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        }
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: []
                },
                {
                    replacementKey: "ActionReminders",
                    values: []
                }
            ]
        }
    ]
};
export default template;